"use strict";

$(window).on("load", function () {
    menu();
    anchorScroll();
    fixedHeader();
    $(window).on("scroll", function () {
        fixedHeader();
    });
});

function anchorScroll() {
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        if ($(".header-menu").hasClass("active")) {
            $(".js-header-burger").removeClass("active");
            $(".header-menu").removeClass("active");
            $(".header-menu").slideUp(250);
        }
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 80
        }, 500);
    });
}

function menu() {
    $(".js-header-burger").on("click", function () {
        $(this).stop().toggleClass("active");
        $(".header-menu").stop().toggleClass("active");
        $(".header-menu").stop().slideToggle(250);
    });
}

function fixedHeader() {
    if ($(window).scrollTop() > 0) {
        $(".header").addClass("fixed");
    }
    else {
        $(".header").removeClass("fixed");
    }
}